import "../scss/style.scss";
import { navToggle } from "./header";
navToggle();

import { map } from "./maplibre";
map();

import { initGallery } from "./embla-carousel"; // Adjust path as needed

document.addEventListener("DOMContentLoaded", () => {
  // 1. Select all embla elements on the page
  const emblaNodes = document.querySelectorAll(".embla");

  // 2. Loop through each node and initialize it
  // We use Array.from or the forEach method on the NodeList
  emblaNodes.forEach((node) => {
    // You can even pass specific options per gallery if needed
    initGallery(node);
  });
});
